import React from 'react';
import { useSelector } from 'react-redux';

import { INewCartEntry } from 'pages/NewCart/ICart';
import { IAppState } from 'config/redux/reducers';
import CartListItem from '../CartListItem';
import FreebieCartListItem from '../FreebieCartListItem';
import OOSCartList from '../OOSCartList';
import { GROWTHBOOK_FLAGS } from '../../constants/growthbook.constants';
import { useFeature } from '@mafc/appshell';
import CardContainer from './CartList.style';
import { Box } from '@mafc/trolly';
import COLORS from 'theme/colors';
import { useTranslation } from 'react-i18next';
import { Marquee, MarqueeTextWrapper, SavedText } from '@mafc/common';

const CartList: React.FC<{
  entries: INewCartEntry[];
  shipmentType: string;
  oosEntries: INewCartEntry[];
  isOOSSubstitutionEnabled: boolean;
  bundleEntries?: INewCartEntry[][];
}> = ({ entries, oosEntries, shipmentType, isOOSSubstitutionEnabled, bundleEntries }) => {
  const allEntires = isOOSSubstitutionEnabled ? entries : [...oosEntries, ...entries];
  const { loadingEntries } = useSelector((state: IAppState) => state.newCart);
  const isCartPromoBundleEnabled = true;
  const { t } = useTranslation();
  const isSamplingProuctEnabled =
    useFeature(GROWTHBOOK_FLAGS.ADTECH_SAMPLING_PRODUCT_ENABLED).on || false;

  const isEntryLoading = (entryNumber: number) => loadingEntries.indexOf(entryNumber) !== -1;
  return (
    <>
      {(!isCartPromoBundleEnabled || (bundleEntries && !bundleEntries.length)) &&
        allEntires.map(entry =>
          isSamplingProuctEnabled && entry.isFreebie ? (
            <FreebieCartListItem entry={entry} key={entry.entryNumber} />
          ) : (
            <CartListItem
              entry={entry}
              shipmentType={shipmentType}
              key={entry.entryNumber}
              isLoading={isEntryLoading(parseInt(`${entry.entryNumber}${entry.offerId}`, 10))}
            />
          )
        )}

      {isCartPromoBundleEnabled &&
        bundleEntries &&
        bundleEntries.length > 0 &&
        bundleEntries.map((bundles: INewCartEntry[]) => {
          const campaign = bundles[0].campaign;
          const isNotLongText = campaign && campaign.longText && campaign.longText.length <= 10;
          return campaign ? (
            <div>
              {campaign.longText && (
                <MarqueeTextWrapper isNotLongText={isNotLongText}>
                  {isNotLongText ? (
                    <div>{campaign.longText}</div>
                  ) : (
                    <Marquee text={campaign.longText} />
                  )}
                </MarqueeTextWrapper>
              )}
              <CardContainer mb={16} backgroundColor={COLORS.WHITE}>
                {bundles.map(entry => {
                  return (
                    <CartListItem
                      isCampaign={true}
                      entry={entry}
                      shipmentType={shipmentType}
                      key={entry.entryNumber}
                      isLoading={isEntryLoading(
                        parseInt(`${entry.entryNumber}${entry.offerId}`, 10)
                      )}
                    />
                  );
                })}
                {campaign.savings && (
                  <Box pb={16}>
                    <SavedText>
                      {t('bundle.savingText', {
                        currency: campaign.savings.currency,
                        value: campaign.savings.value,
                      })}
                    </SavedText>
                  </Box>
                )}
              </CardContainer>
            </div>
          ) : (
            bundles.map(entry => {
              return (
                <CartListItem
                  entry={entry}
                  shipmentType={shipmentType}
                  key={entry.entryNumber}
                  isLoading={isEntryLoading(parseInt(`${entry.entryNumber}${entry.offerId}`, 10))}
                />
              );
            })
          );
        })}

      {isOOSSubstitutionEnabled && (
        <OOSCartList shipmentType={shipmentType} oosEntries={oosEntries} />
      )}
    </>
  );
};

export default CartList;
